import { FC, memo } from 'react';
import { useMyTranslations } from '@hooks/useMyTranslations';
import { IStatusBadgeProps, StatusBadgeTransFields } from './types';
import { statusBadgeTranslations } from './translations';
import { statusColors } from './constants';

export const StatusBadge: FC<IStatusBadgeProps> = memo(({ status }) => {
  const { t } = useMyTranslations<StatusBadgeTransFields>([statusBadgeTranslations.name]);

  return (
    <div
      className={`bg-gradient-to-b  py-[4px] px-[8px] rounded-[6px] w-fit ${statusColors[status]}`}
    >
      <p className="text-white small-text">{t(status)}</p>
    </div>
  );
});
